module.exports = __webpack_public_path__ + "img/28.405e70b5.png";